import { useRemote } from '@code-expert/react';
import { invokeProcedure } from './invokeProcedure.js';
export const makeUseProcedure = (socket, options) => (name, ...args) => useRemote(invokeProcedure(socket, options)(name), ...args);
//# sourceMappingURL=makeUseProcedure.js.map